import { defineComponent, reactive, watch } from 'vue';
export default defineComponent({
    name: 'MapperTooltip',
    props: {
        moduleSerial: {
            type: String,
            default: '',
        },
        inverterSerial: {
            type: String,
            default: '',
        },
        colorCode: {
            type: Number,
            default: 0,
        },
        tilt: {
            type: Number,
            default: 0,
        },
        rotate: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const state = reactive({
            phaseBoxLeft: 0,
            phaseBoxHide: 'visible',
        });
        watch(() => props.colorCode, (code) => {
            state.phaseBoxHide = code === -1 ? 'hidden' : 'visible';
            state.phaseBoxLeft = (code - 1) * 23;
        });
        return {
            state,
        };
    },
});
